import { SelectChangeEvent } from "@mui/material";
import { useState } from "react";

export const useForm = (
  submitCallback: any,
  initialState = {},
  updateCallback: any = null,
  shallReset: boolean = false
) => {
  const [values, setValues] = useState(initialState);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({ ...values, [event.target.name]: event.target.value });
    updateCallback && updateCallback(event.target.name, event.target.value);
  };

  const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    setValues({ ...values, [event.target.name]: event.target.value });
    updateCallback && updateCallback(event.target.name, event.target.value);
  };

  const onDropdownChange = (event: SelectChangeEvent<number>) => {
    setValues({ ...values, [event.target.name]: event.target.value });
    updateCallback && updateCallback(event.target.name, event.target.value);
  };

  const onInput = (name: string, value: string) => {
    setValues({ ...values, [name]: value });
    updateCallback && updateCallback(name, value);
  };

  const onCustomChange = (name: string, value: any) => {
    setValues({ ...values, [name]: value });
    updateCallback && updateCallback(name, value);
  };

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (shallReset) {
      (event.target as any).reset();
    }
    await submitCallback();
  };

  const onReset = async () => setValues({ ...initialState });

  return {
    onBlur,
    onInput,
    onReset,
    onChange,
    onDropdownChange,
    onCustomChange,
    onSubmit,
    values,
  };
};
